import { render, staticRenderFns } from "./AbsencesPending.vue?vue&type=template&id=528ed186"
import script from "./AbsencesPending.vue?vue&type=script&lang=js"
export * from "./AbsencesPending.vue?vue&type=script&lang=js"
import style0 from "./AbsencesPending.vue?vue&type=style&index=0&id=528ed186&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports